export default [
    {
        "id": "cm9vtjomj0007cag11q3i57ms",
        "createdAt": "2025-04-24T20:32:09.835Z",
        "updatedAt": "2025-04-24T20:32:09.835Z",
        "deletedAt": null,
        "number": null,
        "name": "test",
        "song": null,
        "guideFirstName": null,
        "guideLastName": null,
        "guidePhone": null,
        "guideEmail": null,
        "isGuided": false,
        "isFly": false,
        "division": null,
        "tbd": false,
        "contributionId": "cm9votnur0003capfh6u36up9",
        "invoiceItemId": null,
        "Contribution": {
            "id": "cm9votnur0003capfh6u36up9",
            "createdAt": "2025-04-24T18:19:57.316Z",
            "updatedAt": "2025-04-24T18:19:57.316Z",
            "maxParticipants": 8,
            "purchaseId": null,
            "tradeProfileId": "cm9votnu90002capf3jqzkt6m",
            "tradeProfile": {
                "id": "cm9votnu90002capf3jqzkt6m",
                "createdAt": "2025-04-24T18:19:57.297Z",
                "updatedAt": "2025-04-24T18:19:57.297Z",
                "deletedAt": null,
                "companyName": "test company",
                "description": "test trade profile",
                "quantity": 1,
                "totalDonation": 5000,
                "logo": "test",
                "sponsorLevel": null,
                "isFinal": false,
                "userId": "cli10077d003dmc10zbil0o37",
                "user": {
                    "id": "cli10077d003dmc10zbil0o37",
                    "createdAt": "2023-05-24T01:00:03.578Z",
                    "updatedAt": "2025-04-25T16:34:26.406Z",
                    "deletedAt": null,
                    "firstName": "Cullin",
                    "lastName": "Bacak",
                    "role": "SPONSOR",
                    "roles": [
                        "SPONSOR"
                    ],
                    "email": "cullin.b.bacak-1hryy@gmail.com",
                    "phone": "",
                    "stripeId": "cus_S6cVt3LzpvrZg5",
                    "hash": "$argon2id$v=19$m=4096,t=3,p=1$c8NbqfS+M3Gr8/0QD+bMWA$e7FrRRDitXPpdTo0fR/10rtJDnuy3gkATErqaRWBX+k",
                    "allowMultiple": false,
                    "resetPasswordToken": null,
                    "resetPasswordExpires": null
                }
            }
        },
        "Members": [
            {
                "id": "cm9vtjomj0008cag1l42ttilr",
                "createdAt": "2025-04-24T20:32:09.835Z",
                "updatedAt": "2025-04-24T20:32:09.835Z",
                "deletedAt": null,
                "isLeader": true,
                "email": "test@test.com",
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9vtjomj0007cag11q3i57ms",
                "userId": null
            },
            {
                "id": "cm9vtjomj000acag1i20yettb",
                "createdAt": "2025-04-24T20:32:09.835Z",
                "updatedAt": "2025-04-24T20:32:09.835Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9vtjomj0007cag11q3i57ms",
                "userId": null
            },
            {
                "id": "cm9vtjomj000bcag1dteqm8oj",
                "createdAt": "2025-04-24T20:32:09.835Z",
                "updatedAt": "2025-04-24T20:32:09.835Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9vtjomj0007cag11q3i57ms",
                "userId": null
            },
            {
                "id": "cm9vtjomj0009cag10dt2hegj",
                "createdAt": "2025-04-24T20:32:09.835Z",
                "updatedAt": "2025-04-24T20:32:09.835Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9vtjomj0007cag11q3i57ms",
                "userId": null
            }
        ],
        "InvoiceItem": null
    },
    {
        "id": "cm9wbi0rf000bcaw6fdjort4r",
        "createdAt": "2025-04-25T04:54:45.340Z",
        "updatedAt": "2025-04-25T04:54:45.340Z",
        "deletedAt": null,
        "number": null,
        "name": "test",
        "song": null,
        "guideFirstName": null,
        "guideLastName": null,
        "guidePhone": null,
        "guideEmail": null,
        "isGuided": false,
        "isFly": false,
        "division": null,
        "tbd": false,
        "contributionId": "cm9votnur0003capfh6u36up9",
        "invoiceItemId": null,
        "Contribution": {
            "id": "cm9votnur0003capfh6u36up9",
            "createdAt": "2025-04-24T18:19:57.316Z",
            "updatedAt": "2025-04-24T18:19:57.316Z",
            "maxParticipants": 8,
            "purchaseId": null,
            "tradeProfileId": "cm9votnu90002capf3jqzkt6m",
            "tradeProfile": {
                "id": "cm9votnu90002capf3jqzkt6m",
                "createdAt": "2025-04-24T18:19:57.297Z",
                "updatedAt": "2025-04-24T18:19:57.297Z",
                "deletedAt": null,
                "companyName": "test company",
                "description": "test trade profile",
                "quantity": 1,
                "totalDonation": 5000,
                "logo": "test",
                "sponsorLevel": null,
                "isFinal": false,
                "userId": "cli10077d003dmc10zbil0o37",
                "user": {
                    "id": "cli10077d003dmc10zbil0o37",
                    "createdAt": "2023-05-24T01:00:03.578Z",
                    "updatedAt": "2025-04-25T16:34:26.406Z",
                    "deletedAt": null,
                    "firstName": "Cullin",
                    "lastName": "Bacak",
                    "role": "SPONSOR",
                    "roles": [
                        "SPONSOR"
                    ],
                    "email": "cullin.b.bacak-1hryy@gmail.com",
                    "phone": "",
                    "stripeId": "cus_S6cVt3LzpvrZg5",
                    "hash": "$argon2id$v=19$m=4096,t=3,p=1$c8NbqfS+M3Gr8/0QD+bMWA$e7FrRRDitXPpdTo0fR/10rtJDnuy3gkATErqaRWBX+k",
                    "allowMultiple": false,
                    "resetPasswordToken": null,
                    "resetPasswordExpires": null
                }
            }
        },
        "Members": [
            {
                "id": "cm9wbi0rf000ccaw6aqz9l0wd",
                "createdAt": "2025-04-25T04:54:45.340Z",
                "updatedAt": "2025-04-25T04:54:45.340Z",
                "deletedAt": null,
                "isLeader": true,
                "email": "test@test.com",
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9wbi0rf000bcaw6fdjort4r",
                "userId": null
            },
            {
                "id": "cm9wbi0rf000ecaw6ilnv2mu2",
                "createdAt": "2025-04-25T04:54:45.340Z",
                "updatedAt": "2025-04-25T04:54:45.340Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9wbi0rf000bcaw6fdjort4r",
                "userId": null
            },
            {
                "id": "cm9wbi0rf000dcaw69mctky2c",
                "createdAt": "2025-04-25T04:54:45.340Z",
                "updatedAt": "2025-04-25T04:54:45.340Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9wbi0rf000bcaw6fdjort4r",
                "userId": null
            },
            {
                "id": "cm9wbi0rf000fcaw61fl0dz4t",
                "createdAt": "2025-04-25T04:54:45.340Z",
                "updatedAt": "2025-04-25T04:54:45.340Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9wbi0rf000bcaw6fdjort4r",
                "userId": null
            }
        ],
        "InvoiceItem": null
    },
    {
        "id": "cm9x0qu9s0009cay8zs0n731v",
        "createdAt": "2025-04-25T16:41:27.232Z",
        "updatedAt": "2025-04-25T16:41:27.232Z",
        "deletedAt": null,
        "number": null,
        "name": "test",
        "song": null,
        "guideFirstName": null,
        "guideLastName": null,
        "guidePhone": null,
        "guideEmail": null,
        "isGuided": false,
        "isFly": false,
        "division": null,
        "tbd": false,
        "contributionId": "cm9x0q0250003cay8ljfpdl6q",
        "invoiceItemId": null,
        "Contribution": {
            "id": "cm9x0q0250003cay8ljfpdl6q",
            "createdAt": "2025-04-25T16:40:48.078Z",
            "updatedAt": "2025-04-25T16:40:48.078Z",
            "maxParticipants": 8,
            "purchaseId": null,
            "tradeProfileId": "cm9x0q0200002cay8zytfp2bk",
            "tradeProfile": {
                "id": "cm9x0q0200002cay8zytfp2bk",
                "createdAt": "2025-04-25T16:40:48.072Z",
                "updatedAt": "2025-04-25T16:40:48.072Z",
                "deletedAt": null,
                "companyName": "test",
                "description": "test",
                "quantity": 1,
                "totalDonation": 4000,
                "logo": "test",
                "sponsorLevel": null,
                "isFinal": false,
                "userId": "cli0ye24p000ymc10hxdyjazw",
                "user": {
                    "id": "cli0ye24p000ymc10hxdyjazw",
                    "createdAt": "2023-05-24T00:14:50.953Z",
                    "updatedAt": "2025-04-25T16:34:26.424Z",
                    "deletedAt": null,
                    "firstName": "Dalton ",
                    "lastName": "Stewart",
                    "role": "SPONSOR",
                    "roles": [
                        "SPONSOR"
                    ],
                    "email": "ldaltonstewart-vyurr@gmail.com",
                    "phone": "+1 (214) 683-6190",
                    "stripeId": "cus_S6cWbxWw8GAN2I",
                    "hash": "$argon2id$v=19$m=4096,t=3,p=1$c8NbqfS+M3Gr8/0QD+bMWA$e7FrRRDitXPpdTo0fR/10rtJDnuy3gkATErqaRWBX+k",
                    "allowMultiple": false,
                    "resetPasswordToken": null,
                    "resetPasswordExpires": null
                }
            }
        },
        "Members": [
            {
                "id": "cm9x0qu9s000acay8rlpmpkuo",
                "createdAt": "2025-04-25T16:41:27.232Z",
                "updatedAt": "2025-04-25T16:41:27.232Z",
                "deletedAt": null,
                "isLeader": true,
                "email": "test@test.com",
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9x0qu9s0009cay8zs0n731v",
                "userId": null
            },
            {
                "id": "cm9x0qu9s000bcay8p3aisasw",
                "createdAt": "2025-04-25T16:41:27.232Z",
                "updatedAt": "2025-04-25T16:41:27.232Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9x0qu9s0009cay8zs0n731v",
                "userId": null
            },
            {
                "id": "cm9x0qu9s000ccay8sh8aaspe",
                "createdAt": "2025-04-25T16:41:27.232Z",
                "updatedAt": "2025-04-25T16:41:27.232Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9x0qu9s0009cay8zs0n731v",
                "userId": null
            },
            {
                "id": "cm9x0qu9s000dcay8nd7arh5f",
                "createdAt": "2025-04-25T16:41:27.232Z",
                "updatedAt": "2025-04-25T16:41:27.232Z",
                "deletedAt": null,
                "isLeader": false,
                "email": null,
                "phone": null,
                "firstName": "test",
                "lastName": "test",
                "teamId": "cm9x0qu9s0009cay8zs0n731v",
                "userId": null
            }
        ],
        "InvoiceItem": null
    }
];